/**
 * @GestionalePD Admin header switch UI
 */
import PropTypes from 'prop-types';
import { Box, Stack, IconButton } from '@mui/material';

//-------------------------------------------------------------
import { HeaderRoot, HeaderToolbar } from '../dashboardStyles';
import Iconify from '../../../components/iconify';
import ProfileSwitch from './ProfileSwitch';

/**
 * - onOpenNav - Open switch option handler
 * @returns Admin header switch UI
 */
export default function AdminHeader({ onOpenNav }) {
  return (
    <HeaderRoot>
      <HeaderToolbar>
        <IconButton
          onClick={onOpenNav}
          sx={{
            mr: 1,
            color: 'text.primary',
            display: { lg: 'none' },
          }}
        >
          <Iconify icon="eva:menu-2-fill" />
        </IconButton>
        <Box sx={{ flexGrow: 1 }} />
        <Stack
          direction="row"
          alignItems="center"
          spacing={{
            xs: 0.5,
            sm: 1,
          }}
        >
          <ProfileSwitch />
        </Stack>
      </HeaderToolbar>
    </HeaderRoot>
  );
}

// Admin header parameter type declaration
AdminHeader.propTypes = {
  onOpenNav: PropTypes.func,
};
